import React from 'react';
import { useState } from "react";

import {prepareSQFTData} from "../../../canvas/core/workspace/workspaceDataMapper";

const ExportWorkspaceButton = () => {
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    setIsSaving(true);
    try {
      let sqftCalcData = await prepareSQFTData();

      sqftCalcData = Object.assign({}, sqftCalcData, {
        canvasImage: "",
        sqFtSlabImage: "",
        sqFtSlabCalcImage:"",
        sqftApplianceImages: "",
        images3D: ""
      });

      const blob = new Blob([JSON.stringify(sqftCalcData, null, 2)], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "positions.json";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error saving:", error);
    }
    setIsSaving(false);
  };

  return (
    <button onClick={handleSave} disabled={isSaving} className={"btn ui-button2 ui-button2--green"}>
      {isSaving ? "Please wait..." : "Export Layout"}
    </button>
  );
};

export default ExportWorkspaceButton;
